import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormFile } from 'src/core/models/form-file';

@Component({
    selector: 'image',
    templateUrl: 'image.html',
    styleUrls: ['image.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImageComponent implements OnInit {
    @Input() formFile: FormFile;
    @Input() imageUrl: string;
    @Input() type: string = 'profile';
    @Input() rounded: boolean;
    @Input() size: number = 200;
    localImageUrl;

    constructor() { }

    ngOnInit() { }

    fileChanged(ev) {
        if (!this.formFile) {
            console.error('ImageComponent.formFile is required.');
            return;
        }
        this.formFile.file = ev.target.files[0];
        const reader = new FileReader();
        reader.onload = (event: any) => {
            // this.imageUrl = 'url("' + event.target.result + '")';
            this.localImageUrl = event.target.result;
        };
        reader.readAsDataURL(this.formFile.file);
    }
}
